import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';
import { updateProfileRequest } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck'
import { postUploadToS3 } from '../../util/api';
import css from './UploadPassportModal.module.css';
import { Button, Modal, InlineTextButton } from '../../components';
import FileUploader from '../../containers/ProfileSettingsPage/ProfileSettingsForm/FileUplaoder';

export const UploadPassportModal = (props) => {
    const {
        user,
        setIsUploadPassportOpen,
        onUpdateProfile,
        isUploadPassportOpen,
        onManageDisableScrolling,
        setIsConfirmModalOpen,
        updateInProgress
    } = props;

    const dispatch = useDispatch();
    const profile = user?.attributes?.profile || {};
    const { privateData, publicData } = profile;

    const initialPassport = privateData?.idorpassport || null;

    const onSubmit = async (formValues) => {
        let { idorpassport } = formValues;
        const isNewlyAddedDob = false;
        const isPassportUpdated = true;

        if (idorpassport) {
            dispatch(updateProfileRequest());
            try {
                const s3Object = await postUploadToS3(idorpassport);
                idorpassport = s3Object.Key;
                const profile = {
                    privateData: {
                        idorpassport,
                    },
                };
                await onUpdateProfile({ ...profile, isNewlyAddedDob, isPassportUpdated });
                if (typeof window !== 'undefined') {
                    localStorage.setItem('passportUploaded', 'true')
                };
            } catch (err) {
                console.error(err);
                return;
            }
        }


    };
    return (
        <Modal
            id="UploadPassportModal"
            containerClassName={css.uploadPassportModal}
            isOpen={isUploadPassportOpen}
            onClose={() => { setIsUploadPassportOpen(false); }}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
            hideCloseBtn={true}
        >
            <div className={css.content}>


                <h2 className={css.title}>
                    <FormattedMessage id="UploadPassportModal.heading" />
                </h2>

                <Form
                    onSubmit={onSubmit}
                    initialValues={{ idorpassport: initialPassport }}
                    render={({ handleSubmit, form, submitting, pristine }) => (
                        <form onSubmit={handleSubmit} className={css.form}>
                            <div className={css.fieldWrapper}>
                                {/* <label htmlFor="idorpassport">
                    <FormattedMessage id="UploadPassportModal.passportLabel" />
                  </label> */}
                                <FileUploader
                                    form={form}
                                    formId="uploadPassportForm"
                                    initialValues={{ idorpassport: initialPassport, isVerified: publicData?.isVerified || false }}
                                    isModalUpload={true}
                                />
                            </div>
                            <div>
                                <Button type="submit" disabled={submitting || pristine}
                                    inProgress={updateInProgress}
                                    className={css.submitButton}>
                                    <FormattedMessage id="UploadPassportModal.submitButton" />
                                </Button>
                                <InlineTextButton
                                    className={css.closeButton}
                                    type="button"
                                    onClick={() => {
                                        setIsUploadPassportOpen(false);
                                        window.location.reload();
                                    }}
                                >
                                    <FormattedMessage id="UploadPassportModal.doItLater" />
                                </InlineTextButton>
                            </div>
                        </form>
                    )}
                />
            </div>
        </Modal>
    );
}
export default UploadPassportModal;